import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { BeneficiaryGroup } from '@/shared/lib/sj-orm/models/beneficiary.dto';

export const useI18nValues = () => {
  const { t } = useTranslation('entities/beneficiaries', { keyPrefix: 'groups' });

  return useMemo(
    () => ({
      group: (group: BeneficiaryGroup) => t(i18nMap[group]),
    }),
    [t],
  );
};

const i18nMap = {
  [BeneficiaryGroup.FAMILY]: 'family',
  [BeneficiaryGroup.FAMILY_CLAN]: 'familyClan',
  [BeneficiaryGroup.CIRCLE]: 'circle',
};
